export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
export const isEmpty = str => !str || str.length === 0;



// WEBPACK FOOTER //
// ./src/helpers/string.js